import { ZHH_SESSION_LIMIT_ACTION_TYPE } from "./zhh-session-limit.action";

export const ZHH_SESSION_LIMIT_MESSAGE_CONTEXT = {
	get: ZHH_SESSION_LIMIT_ACTION_TYPE.get,
};

export const ZHH_SESSION_LIMIT_MESSAGE_CODE = {
	getError: "M_ZHH_SESSION_LIMIT_GET_ERROR",
};
